import { tncHtml } from './tncHtml'

export const TocContent = () => {
    return <div dangerouslySetInnerHTML={{ __html: tncHtml }} />
}
